module.exports = {
      id: "twittericon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#twittericon",
      toString: function () {
        return this.url;
      }
    }